import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';

import { IReduxState } from 'src/store';
import translations from 'src/_i18n/translations';
import { Preloader } from 'src/components';

import { IProps } from './provider.type';

const IntlProviderConfigured: React.FC<IProps> = (props) => {
  const [loading, setLoading] = useState(true);
  const { children, lang } = props;

  useEffect(() => {
    setLoading(false);
    // eslint-disable-next-line
  }, []);

  return !!loading ? (
    <Preloader gradient={{to: '#ccc', from: '#ddd'}} text="Carregando..." />
  ) : (
    <IntlProvider locale={lang} messages={translations[lang]}>
      {children}
    </IntlProvider>
  );
};

const mapStateToProps = (state: IReduxState) => ({
  lang: state.config.lang,
});

export default connect(mapStateToProps, {})(IntlProviderConfigured);
